import { render, staticRenderFns } from "./portArchiveBerth.vue?vue&type=template&id=575d87ce"
import script from "./portArchiveBerth.vue?vue&type=script&lang=js"
export * from "./portArchiveBerth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports